module.exports = __webpack_public_path__ + "img/slide6_img1.ea081e4a.png";